export const SSE_EVENT_TYPE = {
  status: "status",
  token: "token",
  toolCall: "tool_call",
  toolResult: "tool_result",
  hostToolCall: "host_tool_call",
  final: "final",
  error: "error",
  done: "done",
} as const

type SseEventType = (typeof SSE_EVENT_TYPE)[keyof typeof SSE_EVENT_TYPE]

export interface SseStreamEvent {
  type: SseEventType
  [key: string]: unknown
}

interface ParseResult {
  events: SseStreamEvent[]
  remainder: string
}

export const parseSseEvents = (buffer: string): ParseResult => {
  const events: SseStreamEvent[] = []
  const frames = buffer.split("\n\n")
  const remainder = frames.pop() ?? ""

  for (const frame of frames) {
    const parsedEvent = parseSseFrame(frame)
    if (parsedEvent) {
      events.push(parsedEvent)
    }
  }

  return {events, remainder}
}

const parseSseFrame = (frame: string): SseStreamEvent | null => {
  if (!frame.trim()) {
    return null
  }

  const lines = frame.split("\n")
  let eventName: string | null = null
  const dataLines: string[] = []

  for (const rawLine of lines) {
    const line = rawLine.trimEnd()
    if (!line || line.startsWith(":")) {
      continue
    }
    if (line.startsWith("event:")) {
      eventName = line.slice("event:".length).trim()
      continue
    }
    if (line.startsWith("data:")) {
      dataLines.push(line.slice("data:".length).trimStart())
    }
  }

  if (!eventName || dataLines.length === 0) {
    return null
  }

  try {
    const payload = JSON.parse(dataLines.join("\n")) as SseStreamEvent
    if (payload.type !== eventName) {
      return null
    }
    return payload
  } catch {
    return null
  }
}
